// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3JiYL","fileBtn":"File_fileBtn__1mjtu","closeBtn":"File_closeBtn__yiG9x","fileSelected":"File_fileSelected__3mehG","disabled":"File_disabled__1fpvZ"};